import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6971a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index" }
const _hoisted_2 = { class: "setting" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Settings",
      backgroundColor: "#000",
      fontColor: "#fff",
      menuState: ""
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.choiceList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.title,
          onClick: ($event: any) => ($setup.jumpClick(item))
        }, [
          _createTextVNode(_toDisplayString(item.title) + " ", 1),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "20"
          })
        ], 8, _hoisted_3))
      }), 128))
    ]),
    ($setup.logout)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "nextButton",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clickLogoutFn && $setup.clickLogoutFn(...args)))
        }, "LOG OUT"))
      : _createCommentVNode("", true)
  ]))
}